import script from "./RecommendedJobCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecommendedJobCard.vue?vue&type=script&lang=ts&setup=true"

import "./RecommendedJobCard.vue?vue&type=style&index=0&id=04d0d61c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/MYNAVI_MP_VIEW_G_PROD/workspace/view/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04d0d61c"]])

export default __exports__